/******************************************************************************************
 *	Reseller Service
 ********************************************************************************************/
(function() {
  

  angular.module('rcServices.reseller', []).service(
    'Reseller',
    /* @ngInject */
    function(_, jilResellers, User) {
      this.get = function(resellerId) {
        return jilResellers.resellers.get({id: resellerId}).$promise;
      };

      //Change reseller
      this.resellerChange = function(payload) {
        return jilResellers.resellerChange.save({
            resellerId: User.getResellerID(),
            change: ':change'
          }, payload).$promise;
      };
    }
  );
})();
